import moment from "moment-timezone";

const datePrefix = "$"; //date name prefix for grid.
const dateSeperator = "/"; //date seperator from server;
const dateNameSeperator = "_"; //date seperator in code for grid.
const locale = 'en-GB'

export const DateConstants = { datePrefix, dateSeperator, dateNameSeperator, locale };

/* converts the given date string to date */
export const toDate = (dateString, seperator = DateConstants.dateSeperator) => {
  let dateParts = dateString.split(seperator);
  return new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
}
//Convert minute into milliseconds
export const convertMinutes=(minutes)=> {
	return minutes * 60000;
}

// export const formatTime = (dt) => {
//   let month = dt.getMonth() + 1
//   let Date = (dt.getDate() + '/' + month + '/' + dt.getFullYear() + ' ' + dt.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: false }));
//   return Date;
// }
/* copies the time from dateTime to date object */
export const setTime = (date, dateTime) => {
  date.setHours(dateTime.getHours())
  date.setMinutes(dateTime.getMinutes())
  date.setSeconds(dateTime.getSeconds());
  return date;
}
export const formatTime = (dt) => {
  let month = dt.getMonth() + 1
  let Date = (dt.getDate() + '/' + month + '/' + dt.getFullYear() + ' ' + dt.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: false }));
  return Date;
}
export const formatAMPMTime = (dt) => {
  let month = dt.getMonth() + 1
  let getDate = (dt.getDate() + '/' + month + '/' + dt.getFullYear() + ' ' + dt.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }));
  return getDate;
}


// export const msToHMS=( duration )=> {
  
//     var  minutes = parseInt((duration/(1000*60))%60)
//         , hours = parseInt((duration/(1000*60*60))%24);

//     hours = (hours < 10) ? "0" + hours : hours;
//     minutes = (minutes < 10) ? "0" + minutes : minutes;
//     // seconds = (seconds < 10) ? "0" + seconds : seconds;

//     return hours + ":" + minutes 
//   // // 1- Convert to seconds:
//   // var seconds = ms / 1000;
//   // // 2- Extract hours:
//   // var hours = parseInt( seconds / 3600 ); // 3,600 seconds in 1 hour
//   // seconds = seconds % 3600; // seconds remaining after extracting hours
//   // // 3- Extract minutes:
//   // var minutes = parseInt( seconds / 60 ); // 60 seconds in 1 minute
//   // // 4- Keep only seconds not extracted to minutes:
//   // seconds = seconds % 60;
//   // return hours+":"+minutes
// }

/* returns the date in a ISOish format */
export const formatISO = (date) => {
  return date.toISOString();
  // const offsetMs = date.getTimezoneOffset() * 60 * 1000;
  // const msLocal = date.getTime() - offsetMs;
  // const dateLocal = new Date(msLocal);
  // const iso = dateLocal.toISOString();
  // const isoLocal = iso.slice(0, 19);
  // return isoLocal;
}
//format for appending time zone

//Remove / from date 
export const reversedDate = (date) => {
  return date.split("/").reverse().join("-")
  // const offsetMs = date.getTimezoneOffset() * 60 * 1000;
  // const msLocal = date.getTime() - offsetMs;
  // const dateLocal = new Date(msLocal);
  // const iso = dateLocal.toISOString();
  // const isoLocal = iso.slice(0, 19);
  // return isoLocal;
}


export const formatISOWithoutOffset = (date) => {
  // return date.toISOString();
  const offsetMs = date.getTimezoneOffset() * 60 * 1000;
  const msLocal = date.getTime() - offsetMs;
  const dateLocal = new Date(msLocal);
  const iso = dateLocal.toISOString();
  const isoLocal = iso.slice(0, 19);
  return isoLocal;
}

//get date and time based on date selection
export const getCurrentDate = (date, currentDate) => {
  var dateParts = date.split("/");
  var hours = currentDate.getHours();
  var minutes = currentDate.getMinutes();
  // month is 0-based, that's why we need dataParts[1] - 1
  var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0], hours, minutes);

  return dateObject
}

export const msToHMS=( duration )=> {
  
  var  minutes = parseInt((duration/(1000*60))%60)
      , hours = parseInt((duration/(1000*60*60))%24);

  hours = (hours < 10) ? "0" + hours : hours;
  minutes = (minutes < 10) ? "0" + minutes : minutes;
  // seconds = (seconds < 10) ? "0" + seconds : seconds;

  return hours + ":" + minutes 
// // 1- Convert to seconds:
// var seconds = ms / 1000;
// // 2- Extract hours:
// var hours = parseInt( seconds / 3600 ); // 3,600 seconds in 1 hour
// seconds = seconds % 3600; // seconds remaining after extracting hours
// // 3- Extract minutes:
// var minutes = parseInt( seconds / 60 ); // 60 seconds in 1 minute
// // 4- Keep only seconds not extracted to minutes:
// seconds = seconds % 60;
// return hours+":"+minutes
}

export const setUpdateTime = (d, currentDate) => {
  // let val= new Date(d);
  // let time = currentDate.getTime()



  let month = d.getMonth()
  let date = d.getDate()
  let year = d.getFullYear()
  var hours = currentDate.getHours();
  var minutes = currentDate.getMinutes();
  let newDate = new Date(year, month, date, hours, minutes)
  // console.log(newDate)
  // console.log(newDate)
  return new Date(newDate)
}

export const getIST = (d) => {
  // let val= new Date(d);
  // let time = currentDate.getTime()



  let month = d.getMonth() + 1
  let date = d.getDate()
  let year = d.getFullYear()

  if (month.toString().length == 1) {
    month = '0' + month
  }
  if (date.toString().length == 1) {
    date = '0' + date
  }

  let value = year + '-' + month + '-' + date
  // console.log(newDate)
  // console.log(newDate)
  return value
}


/* Used in rostering grid to name the date columns from date string */
export const getDateName = (dateString) => DateConstants.datePrefix + dateString.split(DateConstants.dateSeperator).join(DateConstants.dateNameSeperator);
/* Used in rostering grid to create the date column name from date object */
export const createDateName = (date) => DateConstants.datePrefix + date.toLocaleDateString(locale).split(DateConstants.dateSeperator).join(DateConstants.dateNameSeperator);

export const getDateFromDateName = (dateName) => toDate(dateName.slice(1).split(DateConstants.dateNameSeperator).join(DateConstants.dateSeperator))

export const today = () => resetTime(new Date);

export const isPastDate = (date) => date < today();

export const isPastMonth = (month) => {
  console.log("month", month)

  let year = month.getFullYear()
  month = month.getMonth()

  let currentYear = today().getFullYear()
  let currentMonth = today().getMonth()
  console.log("v", year, currentYear)

  //  console.log('currentMonth',currentMonth)
  if (month < currentMonth && year <= currentYear) {
    return true
  }
  return false


}

/* Gives the date in DD/MM/YYYY format if seperator ="/" */
export const getServerDate = (date, prepend = true) => {
  let month = +date.getMonth() + 1;
  let day = date.getDate();
  if (prepend) {
    month = month > 9 ? month : "0" + month;
    day = day > 9 ? day : "0" + day;
  }
  return [day, month, date.getFullYear()].join(DateConstants.dateSeperator);
}

export const getNextDate = (currentDate) => {


  return currentDate.setDate(currentDate.getDate() + 1);
}

/* r    eturns a new date with time set as 0 */
export const resetTime = (date) => {
  let d = new Date(date)
  d.setHours(0, 0, 0, 0);
  return d;
}

export const resetSeconds = (date) => {
  let d = new Date(date)
  d.setSeconds(0)
  return d;
}

export const formatAMPM = (date) => {
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? '0' + minutes : minutes;
  var strTime = hours + ':' + minutes + ' ' + ampm;
  return strTime;
}

export const setTimeToDate = (date, time) => {
  const convDate = new Date(date);
  const convTime = new Date(time);
  convDate.setHours(convTime.getHours())
  convDate.setMinutes(convTime.getMinutes())
  convDate.setSeconds(convTime.getSeconds());
  return convDate;
}

export const updatedTime = (date) => {
  // let dateVal = new Date()
  // console.log("date val",dateVal,new Date(date))
  var seconds = Math.floor((new Date() - new Date(date)) / 1000);
  var interval = Math.floor(seconds / 31536000);

  if (interval > 1) {
    return interval + " years";
  }
  interval = Math.floor(seconds / 2592000);
  if (interval > 1) {
    return interval + " months";
  }
  interval = Math.floor(seconds / 86400);
  if (interval > 1) {
    return interval + " days";
  }
  interval = Math.floor(seconds / 3600);
  if (interval > 1) {
    return interval + " hours";
  }
  interval = Math.floor(seconds / 60);
  if (interval >= 1) {
    return interval + " minutes";
  }
  return Math.floor(seconds) + " seconds";
}

export const getLocalDate = (d) => {
  // var d = new Date(date),
  // console.log(" value date",d)
  var month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2)
    month = '0' + month;
  if (day.length < 2)
    day = '0' + day;

  return [year, month, day].join('-');
}

// Validates whether Z is attached to the date String
// if it is not present then it adds it and returns the date.
export const validateZinUTC = (str) => {
  if (str.charAt(str.length - 1) !== 'Z') {
    str += 'Z';
  }
  return str;
}

export const timeAMPM = (time) => {
  let timeString = time.split('T')[1]
  // var timeString = "18:00:00";
  var hourEnd = timeString.indexOf(":");
  var H = +timeString.substr(0, hourEnd);
  var hr = H % 12 || 12;
  var ampm = H < 12 ? " AM" : " PM";
  time = hr + timeString.substr(hourEnd, 3) + ampm;
  return time
}

export const setUTCTime = (date) => {
  console.log(date)
  return date + 'T00:00:00Z'
}

export const convertSignalRTimeStamp = (timeStamp) => {
  if (!timeStamp) return "";
  const YYYY = timeStamp.substr(0, 4);
  const MM = timeStamp.substr(4, 2);
  const DD = timeStamp.substr(6, 2);
  const hh = timeStamp.substr(8, 2);
  const mm = timeStamp.substr(10, 2);
  const ss = timeStamp.substr(12, 2);
  return `${DD}-${MM}-${YYYY} ${hh}:${mm}:${ss}`;
}
export const convertSignalRDateTimeStamp = (timeStamp) => {
  if (!timeStamp) return "";
  const utcTime = moment(timeStamp,"MM/DD/YYYY HH:mm:ss").format("YYYY-MM-DDTHH:mm:ss") + "Z";
  return moment(utcTime).format("DD-MM-YYYY HH:mm:ss");
}

export const getHoursFromMins = (mins) => {
  if (mins < 0) {
    // throw new RangeError("Valid input should be less than 0");
    return null;
  }
  var h = mins / 60 | 0,
    m = mins % 60 | 0;
  return `${h}:${m}`;
}

export const getHoursFromSeconds = (seconds) => {
  if (seconds < 0)
    return null;
  const totalMins = seconds / 60 | 0;
  const h = totalMins / 60 | 0;
  const m = totalMins % 60;
  return `${h}:${m}`;
}

export const convertSecondsToDaysHoursMinSec = (seconds) => {
  seconds = seconds || 0;
  seconds = Number(seconds);
  seconds = Math.abs(seconds);

  var d = Math.floor(seconds / (3600 * 24));
  var h = Math.floor(seconds % (3600 * 24) / 3600);
  var m = Math.floor(seconds % 3600 / 60);
  var s = Math.floor(seconds % 60);
  var parts = new Array();

  if (d > 0) {
    var dDisplay = d > 0 ? d + ' ' + (d == 1 ? "day" : "days") : "";
    parts.push(dDisplay);
  }

  if (h > 0) {
    var hDisplay = h > 0 ? h + ' ' + (h == 1 ? "hr" : "hr") : "";
    parts.push(hDisplay)
  }

  if (m > 0) {
    var mDisplay = m > 0 ? m + ' ' + (m == 1 ? "min" : "min") : "";
    parts.push(mDisplay)
  }

  if (s > 0) {
    var sDisplay = s > 0 ? s + ' ' + (s == 1 ? "sec" : "sec") : "";
    parts.push(sDisplay)
  }

  return parts.join(' ', parts);
}

export const convertSecondsToDaysHoursMinSecInDigits = (seconds) => {
  seconds = seconds || 0;
  seconds = Number(seconds);
  seconds = Math.abs(seconds);

  var d = Math.floor(seconds / (3600 * 24));
  var h = Math.floor(seconds % (3600 * 24) / 3600);
  var m = Math.floor(seconds % 3600 / 60);
  // var s = Math.floor(seconds % 60);
  let value = d+':'+h+':'+m
//   // var parts = new Array();
//  console.log("------>",d+':'+h+':'+m )
//   if (d > 0) {
//     var dDisplay = d > 0 ? d + ' ' + ':' : "";
//     parts.push(dDisplay);
//   }

//   if (h > 0) {
//     var hDisplay = h > 0 ? h + ' ' + (h == 1 ? "hr" : "hr") : "";
//     parts.push(hDisplay)
//   }

//   if (m > 0) {
//     var mDisplay = m > 0 ? m + ' ' + (m == 1 ? "min" : "min") : "";
//     parts.push(mDisplay)
//   }

//   if (s > 0) {
//     var sDisplay = s > 0 ? s + ' ' + (s == 1 ? "sec" : "sec") : "";
//     parts.push(sDisplay)
//   }

  return value
}
export const convertSecondsToHMmSs= (seconds) => {
  const m = (seconds / 60) % 60;
  const h = (seconds / (60 * 60)) % 24;
  return h+":"+m;
}